import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "path",
  "use": "path-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" fill=\"currentColor\" id=\"path\"><path d=\"M18 4v4h-4V4h4m2-2h-8v8h8V2zM30 4v4h-4V4h4m2-2h-8v8h8V2z\" /><path d=\"M17 23.14V16H5v-6h3V2H0v8h3v8h12v5.14a4 4 0 102 0zM27 12h2v2h-2zM27 16h2v2h-2z\" /><path d=\"M15 12h2v2h-2zM23 16h2v2h-2zM19 16h2v2h-2z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/img/svg/path.svg
// module id = J1uX
// module chunks = 39 44